<template>
  <div id="app">
<van-form @submit="onSubmit">
    <van-image
      width="100%"
      height="50"
      src="../../static/image/info1.jpg"
    />
    <van-field  class="info-dtitle" error required  label="上传照片" :border="false"  readonly   />
    <p class="info-wz" style="background: #FFFFFF;">平台保证每个用户的信息安全，请务必上传单身朋友的真实照片，否则将导致审核不通过无法展示！</p>

    <div class="height100" style="background: #FFFFFF;">
      <van-uploader
      class="mt-3"
      :max-size="3 * 1024 * 1024"
      :before-read="beforeRead"
      @oversize="onOversize"
      v-model="picurllist"
      :max-count="6"
      :before-delete="picurlDelete"
      >
    </van-uploader>
  <!-- 剪裁图片组件 -->
      <van-popup
        class="bg-tran"
        v-model="showCropper"
        closeable
        position="top"
        :style="{ height: '100%' }"
      >
        <div class="flex-column-center height100">
          <app-VueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :full="option.full"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
            :high="option.high"
            :mode="option.mode"
          ></app-VueCropper>
          <div class="popup_bottom">
            <div class="bottom_item"><span @click="cancelCropper">取消</span></div>
            <div class="bottom_item"><span @click="rotateImage" class="font18"><van-icon name="replay" /></span></div>
            <div class="bottom_item"><span @click="getCropBlob">确定</span></div>
          </div>
        </div>
      </van-popup>
    </div>
    <van-field  class="info-dtitle"  error   required  label="基础资料"  :border="false" readonly />

    <van-field v-model="ncnickname" label="昵称" name='ncnicknamenc'  class="info-public-title"  placeholder="输入昵称" input-align="right" />
    <van-field name="sex" label="性别" input-align="right">
      <template #input>
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio name="1" checked-color="#ff5b5a">男</van-radio>
          <van-radio name="2" checked-color="#ff5b5a">女</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field  readonly   clickable name="csname" :value="timesr"  label="出生日期"  placeholder="点击选择出生日期" @click="showPicker  = true"  input-align="right" />
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker  type="date" v-model="currentDate"  :min-date="minDate"  :max-date="maxDate"   @confirm="onConfirm"   @cancel="showPicker = false"  />
    </van-popup>
    <van-field  readonly  clickable name="sgname"  :value="Sgvalue" label="身高(cm)" placeholder="点击选择身高" @click="showPickerSg = true"  input-align="right"  />
    <van-popup v-model="showPickerSg" position="bottom">
      <van-picker  show-toolbar :columns="columns"   @confirm="Sg"  @cancel="showPickerSg = false"  />
    </van-popup>
    <van-field  readonly  clickable name="tzname"  :value="Tzvalue" label="体重(kg)" placeholder="点击选择体重" @click="showPickerTz = true"  input-align="right"  />
    <van-popup v-model="showPickerTz" position="bottom">
      <van-picker  show-toolbar  :columns="columnsTz"   @confirm="Tz"  @cancel="showPickerTz = false"  />
    </van-popup>

    <van-field  readonly  clickable name="xlname"  :value="Xlvalue" label="学历" placeholder="点击选择学历" @click="showPickerXl = true"  input-align="right"  />
    <van-popup v-model="showPickerXl" position="bottom">
      <van-picker  show-toolbar  :columns="columnsXl"   @confirm="Xl"  @cancel="showPickerXl = false"  />
    </van-popup>
    <van-field v-model="zynickname" name="zyname" label="职业"  class="info-public-title"  placeholder="输入职业" input-align="right" />

    <van-field name="hyname" label="婚姻状况" input-align="right">
      <template #input>
        <van-radio-group v-model="hy" direction="horizontal" @change="hyzt">
          <van-radio name="1" checked-color="#ff5b5a">未婚</van-radio>
          <van-radio name="2" checked-color="#ff5b5a">离异</van-radio>
        </van-radio-group>
      </template>
    </van-field>


    <van-field name="hzname" label="是否有孩子" input-align="right"  v-show="isShow">
      <template #input>
        <van-radio-group v-model="hz" direction="horizontal">
          <van-radio name="1" checked-color="#ff5b5a">是</van-radio>
          <van-radio name="2" checked-color="#ff5b5a">否</van-radio>
        </van-radio-group>
      </template>
    </van-field>

    <van-field class="fabu-iput" name="xzaddress" label="籍贯" v-model="addressvalue" clearable  placeholder="选择籍贯" readonly  input-align="right"  @click="showArea = true"></van-field>
    <!-- 省市区 -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
       :area-list="areaList"
       @confirm="onConfirms"
       @cancel="showArea = false"
      />
    </van-popup>


  <van-field class="fabu-iput" name="xjdaddress" label="现居地" v-model="xjdvalue" clearable  placeholder="选择现居地" readonly input-align="right"  @click="xjdshowArea = true"></van-field>
    <!-- 省市区 -->
    <van-popup v-model="xjdshowArea" position="bottom">
      <van-area
       :area-list="ajdareaList"
       @confirm="xjdonConfirms"
       @cancel="xjdshowArea = false"
      />
    </van-popup>
    <div class="h-15 bj-f7f7f7"></div>
    <van-field  class="info-dtitle" error required  label="择偶要求" :border="false"  readonly   />
    <!-- 年龄 -->
    <van-field class="fabu-iput" name="zonlname" label="年龄" v-model="zovalue" clearable  placeholder="选择年龄" readonly  input-align="right"  @click="zoshowArea = true"></van-field>
    <van-popup v-model="zoshowArea" position="bottom">
      <van-picker show-toolbar title="标题" :columns="columnsnl"  @confirm="nlok" @cancel="zoshowArea = false" />
    </van-popup>
    <!-- 身高 -->
    <van-field class="fabu-iput" name="sgnames" label="身高(cm)" v-model="sgvalues" clearable  placeholder="选择身高" readonly  input-align="right"  @click="sgshowArea = true"></van-field>
    <van-popup v-model="sgshowArea" position="bottom">
      <van-picker show-toolbar title="标题" :columns="columnssg"  @confirm="sgok" @cancel="sgshowArea = false" />
    </van-popup>
    <!-- 学历 -->
    <van-field class="fabu-iput" name="zoxlname" label="学历" v-model="xlvalues" clearable  placeholder="选择学历" readonly  input-align="right"  @click="xlshowArea = true"></van-field>
    <van-popup v-model="xlshowArea" position="bottom">
      <van-picker show-toolbar title="标题" :columns="columnsxl"  @confirm="xlok" @cancel="xlshowArea = false" />
    </van-popup>

    <van-field name="zosrname" v-model="zosr" center clearable label="年收入"  placeholder="未填写"  input-align="right"  type="number" >
      <template #button>
          万元以上
      </template>
    </van-field>

    <van-field name="hyzkname" label="婚姻状况" input-align="right">
      <template #input>
        <van-radio-group v-model="hyzk" direction="horizontal">
          <van-radio name="1" checked-color="#ff5b5a">未婚</van-radio>
          <van-radio name="2" checked-color="#ff5b5a">离异</van-radio>
          <van-radio name="3" checked-color="#ff5b5a">都可以</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <div class="h-15 bj-f7f7f7"></div>
    <van-field  class="info-dtitle" error   label="资料补充" :border="false"  readonly   />
    <van-field v-model="gzdw" name="gzdw" label="工作单位"  class="info-public-title"  placeholder="非必填" input-align="right" />
    <van-field v-model="nsr"  name="nsr" label="年收入"  class="info-public-title"  placeholder="非必填" input-align="right" />
    <van-field v-model="zfqk" name="zfqk" label="住房情况"  class="info-public-title"  placeholder="非必填" input-align="right" />
    <van-field v-model="clqk" name="clqk" label="车辆情况"  class="info-public-title"  placeholder="非必填" input-align="right" />
     <p class="info-wz info-wz-ts">提示：发布后需要后台审核资料，审核成功后，发布到首页！（当前审核状态：{{zttext}}）</p>
      <div style="margin: 16px;">
        <van-button round block type="info" color="#fc597c" native-type="submit">保存</van-button>
      </div>
    </van-form>

    <van-notify v-model="tishi" type="warning">
      <van-icon name="bell" style="margin-right: 4px;" />
      <span>请开通会员；非会员无法展示</span>
    </van-notify>


  </div>
</template>

<script>
import areaList from "../../static/Areajs/area.js"
import { VueCropper } from 'vue-cropper'
import Vue from 'vue';
import { Toast,Notify } from 'vant';
Vue.use(Toast);
export default {
	data() {
		return {
      tishi:false,
      zttext:'',
      isShow:false,
      hyzk:'',
      gzdw:'',
      nsr:'',
      zfqk:'',
      clqk:'',
      zosr:'',
      xlvalues:'',
      xlshowArea:false,
      columnsxl:[
        {
          values:['初中','高中','中专','大专','本科','研究生','硕士','博士'],
          defaultIndex: 0,
        },
        {
          values:['初中','高中','中专','大专','本科','研究生','硕士','博士'],
          defaultIndex: 0,
        }
      ],
      zovalue:'',
      zoshowArea:false,
      columnsnl: [
        // 第一列
        {
          values: ['18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79','80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99','100'],
          defaultIndex: 0,
        },
        // 第二列
        {
          values: ['18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79','80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99','100'],
          defaultIndex: 0,
        },
      ],
      sgvalues:'',
      sgshowArea:false,
      columnssg: [
        // 第一列
        {
          values: ['150', '151', '152', '153', '154', '155', '156', '157', '158', '159', '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', '170', '171', '172', '173', '174', '175', '176', '177', '178', '179','180','181','182','183','184','185','186','187','188','189','190','191','192','193','194','195','196','197','198','199','200','201','202','203','204','205','206','207','208','209','210'],
          defaultIndex: 0,
        },
        // 第二列
        {
          values: ['150', '151', '152', '153', '154', '155', '156', '157', '158', '159', '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', '170', '171', '172', '173', '174', '175', '176', '177', '178', '179','180','181','182','183','184','185','186','187','188','189','190','191','192','193','194','195','196','197','198','199','200','201','202','203','204','205','206','207','208','209','210'],
          defaultIndex: 0,
        },
      ],
      text:'',
      ncnickname:'',
      radio:'1',
      timesr:'',
      showPicker: false,
      minDate: new Date(1980, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(1990, 0, 1),
      columns: ['150', '151', '152', '153', '154', '155', '156', '157', '158', '159', '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', '170', '171', '172', '173', '174', '175', '176', '177', '178', '179','180','181','182','183','184','185','186','187','188','189','190','191','192','193','194','195','196','197','198','199','200','201','202','203','204','205','206','207','208','209','210'],
      showPickerSg:false,
      Sgvalue:"",
      showPickerTz:false,
      Tzvalue:"",
      columnsTz:['40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60','61','62','63','64','65','66','67','68','69','70','71','72','73','74','75','76','77','78','79','80','81','82','83','84','85','86','87','88','89','90','91','92','93','94','95','96','97','98','99','100'],
      showPickerXl:false,
      Xlvalue:"",
      columnsXl:['初中','高中','中专','大专','本科','研究生','硕士','博士'],
      zynickname:'',
      hy:'1',
      hz:'0',
      showArea: false,
      areaList: areaList, // 数据格式见 Area 组件文档
      xjdshowArea: false,
      ajdareaList: areaList, // 数据格式见 Area 组件文档
      addressvalue:'',
      xjdvalue:'',
      picurl:[],
      picurllist:[],
      showCropper: false, // 截图弹窗遮罩默认隐藏
      imageAccept: "/jpg,/png,/jpeg",
      imageFileName: '',
      option: {
        img: '',
        outputSize: 0.7,
        info: false, // 裁剪框的大小信息
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: window.innerWidth - 130 + 'px', // 默认生成截图框宽度
        autoCropHeight: window.innerWidth - 130 + 'px', // 默认生成截图框高度
        high: true, // 是否按照设备的dpr 输出等比例图片
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [0.8, 0.8], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        mode: '100% auto' // 图片默认渲染方式
     },
		}
  },

  created:function () {
      this.$emit('footer', false);
  },

  components: {
      'app-VueCropper':VueCropper,
  },

  mounted () {
    this.recordapi();
  },

	methods: {

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/member",{'userid':userid}).then(res => {
          console.log(res);
          that.info= res.info;
          that.timesr =  res.info.csname
          that.ncnickname =  res.info.ncnicknamenc
          that.hy =  res.info.hyname
          that.xjdvalue =  res.info.xjdaddress
          that.addressvalue =  res.info.xzaddress
          that.Sgvalue =  res.info.sgname
          that.Tzvalue =  res.info.tzname
          that.Xlvalue =  res.info.xlname
          that.zynickname =  res.info.zyname
          that.hyzk =  res.info.hyzkname
          that.radio=  res.info.sex
          that.hz=  res.info.hzname
          that.sgvalues=  res.info.sgnames
          that.zovalue=  res.info.zonlname
          that.xlvalues=  res.info.zoxlname
          that.zosr=  res.info.zosrname
          that.gzdw=  res.info.gzdw
          that.nsr=  res.info.nsr
          that.zfqk=  res.info.zfqk
          that.clqk=  res.info.clqk
          that.picurllist=  res.info.picurllist
          console.log(res.info.hyname);
          if(res.info.hyname == '2'){
             that.isShow = true
          }
          if(res.info.status == 1){
            that.zttext = "审核通过";
          }else if(res.info.status == 2){
            that.zttext = "等待审核";
          }else if(res.info.status == 3){
            that.zttext = "审核未通过请认真完善资料";
          }else{
            that.zttext = "未完善";
          }

          if(res.info.vip == '1'){
            this.tishi = true;
            // setTimeout(() => {
            //   this.tishi = false;
            // }, 2000);
          }



        });
    },

     onSubmit(values) {
       var that = this;
        var userid = this.$cookieStore.getCookie('userid');
        if(that.picurllist== 0){
             var picurllist_list = '';
        }else{
           var picurllist_list = that.picurllist;
        }
        console.log( that.picurllist);
        that.$api.post("/Member/memberinfo",{'values':values,'userid':userid,'picurllists':picurllist_list}).then(res => {
            console.log(res);
            if(res.code == 1){
              this.$toast(res.msg);
            }else{
              this.$toast(res.msg);
            }
            // this.$router.push({path:'/record/index',query:{setid:2}});
            // that.deletetp = false;
            // that.disabledjy = true;
            // that.buttext = "正 在 审 核 中";
            // Toast(res.msg);
        });

        // console.log(that.picurllist)
        // var picurl = that.picurllist.join();
      },

    xlok(values) {
      this.xlvalues = values[0]+"~"+values[1]
      this.xlshowArea = false;
    },
    // 择偶要求 身高
    sgok(values) {
      this.sgvalues = values[0]+"~"+values[1]
      this.sgshowArea = false;
    },
    // 择偶要求 年龄
    nlok(values) {
      this.zovalue = values[0]+"~"+values[1]
      this.zoshowArea = false;
    },
    // 选择省市区  现居地
    xjdonConfirms(values) {
      this.xjdvalue = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/');
      this.xjdshowArea = false;
    },
    // 选择省市区  籍贯
    onConfirms(values) {
      this.addressvalue = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/');
      this.showArea = false;
    },
    // 婚姻
    hyzt(e){
      if(e==2){
        this.isShow = true;
      }else{
        this.isShow = false;
      }
    },
    // 学历
    Xl(value) {
       this.Xlvalue = value;
       this.showPickerXl = false;
     },
    // 体重
   Tz(value) {
      this.Tzvalue = value;
      this.showPickerTz = false;
    },
    // 身高
    Sg(value) {
      this.Sgvalue = value;
      this.showPickerSg = false;
    },
    // 生日
    onConfirm(date) {
      this.timesr = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      this.showPicker = false;
    },
		// 上传文件过大
		onOversize() {
		  this.$toast('图片不能大于3M');
		},

		// 获取文件后缀
		getFileSuffix(fileName) {
		  return fileName.match(/\/\w+$/)[0].toLowerCase();
		},

		// 选择图片上传前操作，调起剪裁组件
		beforeRead(file) {
      console.log(file);
		  if (!this.imageAccept.includes(this.getFileSuffix(file.type))) {
		    return this.$toast('请上传 jpg/png 格式图片');
		  }
		  this.showCropper = true;
		  this.imageFileName = file.name;
		  // 本地图片转成base64，用于截图框显示本地图片
		  this.imageToBase64(file);
    },
    // 将本地图片转化为Base64，否则vue-cropper组件显示不出要本地需要剪裁的图片
	    imageToBase64(file) {
	      let reader = new FileReader();
	      reader.readAsDataURL(file);
	      reader.onload = () => {
	        // 截图框中的图片
	        this.option.img = reader.result;
	      }
	      reader.onerror = function (error) {
	        console.log('Error: ', error)
	      }
	    },

	    // 确认剪裁并上传图片
	    async getCropBlob() {
	      // this.$toast('上传中', 0);
	      let formData = new FormData();
	      this.$refs.cropper.getCropData((data) => {
            // console.log(data);
             var that = this
             that.$api.post("/Upload/uploadcord",{'file':data}).then(res => {
               console.log(res);
                 if(res.code==1){
                    this.showCropper = false;
                     // file.status = 'done';
                     // file.message = res.data;
                     // file.content = res.data;
                     console.log(res.data);
                     // that.yyzz =[{url: res.user.yyzz}];
                     this.picurllist.push({url: res.data});
                     console.log(this.picurllist);
                 }else{
                   setTimeout(() => {
                     file.status = 'failed';
                     file.message = '上传失败';
                   }, 1000);
                 }
             })
	      })
	    },

	    // 旋转图片
	    rotateImage() {
	      this.$refs.cropper.rotateRight();

	    },

	    // 取消截图上传头像
	    cancelCropper() {
	      this.showCropper = false; // 隐藏切图遮罩
	      this.showPopup = true;
	    },


      // 图片删除方法
       deleteimg(imgurl){
         var that=this;
         this.isloadImg = true;
         that.$api.get("/Upload/imgdelete",{'imgurl':imgurl}).then(res => {
             // console.log(res);
             Toast(res.msg);
         });
       },

      // 删除图片
      picurlDelete(file) {
        console.log(file);
          var that = this;
          var imgurl = file.url;   // 删除的数据
         const findThisNum = that.picurllist.findIndex(x => x === imgurl )
         console.log(imgurl)
         that.picurllist.splice(findThisNum, 1)

          that.deleteimg(imgurl);
          return new Promise((resolve, reject) => {
            console.log("删除文件的回调,afterDelete");
            this.isloadImg = false;
            resolve();
          });
      },
	}
}
</script>



<style>

</style>



// WEBPACK FOOTER //
// src/components/Memberinfo.vue